import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { getJudgeMeData } from "../../lib/judgeme";

// Judge.me's preloader scans the DOM before React mounts; ask it to reload once widgets exist.
const reloadJudgeMe = () => {
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (window.jdgmCacheServer?.reloadAll) {
      window.jdgmCacheServer.reloadAll();
      clearInterval(timer);
    } else if (tries >= 20) {
      clearInterval(timer);
    }
  }, 500);
  return timer;
};

export const JudgeMeReviews = () => {
  // Single source of truth: the official Judge.me product widget, loaded live.
  // No native/fallback review rendering — if Judge.me fails, the section hides gracefully.
  const [widgetHtml, setWidgetHtml] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getJudgeMeData().then((res) => {
      if (cancelled) return;
      if (res?.widget) setWidgetHtml(res.widget);
    });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!widgetHtml) return;
    const preloaderTimer = reloadJudgeMe();
    const container = document.querySelector('[data-testid="judgeme-review-widget"]');
    if (!container) return;

    // The container can receive content from BOTH Judge.me's own renderer and our
    // cached fallback (race on slow connections) -> keep exactly one widget copy
    // and hide any gallery block that has no real media.
    const cleanup = () => {
      const copies = container.querySelectorAll(".jdgm-rev-widg");
      for (let i = 0; i < copies.length - 1; i += 1) copies[i].remove();
      container.querySelectorAll(".jdgm-gallery").forEach((g) => {
        g.style.display = g.querySelector("img, video, iframe") ? "" : "none";
      });
    };

    const observer = new MutationObserver(cleanup);
    observer.observe(container, { childList: true, subtree: true });

    // Fallback: inject sanitized cached HTML ONLY if Judge.me itself failed to render.
    const fallbackTimer = setTimeout(() => {
      if (!container.querySelector(".jdgm-rev-widg")) {
        container.innerHTML = DOMPurify.sanitize(widgetHtml, {
          ADD_TAGS: ["style"],
          ADD_ATTR: ["target"],
        });
      }
      container.querySelectorAll(".jdgm-temp-hiding-style").forEach((s) => s.remove());
      cleanup();
    }, 4000);
    const settleTimer = setTimeout(cleanup, 8000);

    return () => {
      observer.disconnect();
      clearInterval(preloaderTimer);
      clearTimeout(fallbackTimer);
      clearTimeout(settleTimer);
    };
  }, [widgetHtml]);

  if (!widgetHtml) return null;

  return (
    <section id="reviews" className="bg-[#FFFDF9] border-t border-[rgba(58,42,37,0.08)] scroll-mt-24" data-testid="judgeme-reviews-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">Verified Feedback</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] leading-tight" data-testid="judgeme-reviews-heading">
          Customer Reviews
        </h2>
        <p className="mt-3 mb-10 text-sm sm:text-base font-light text-[#756A64]" data-testid="judgeme-product-label">
          Verified reviews for the CELUSTA Leave-In Conditioner.
        </p>
        <div
          className="jdgm-widget jdgm-review-widget jdgm-outside-widget"
          data-id="15964123070794"
          data-product-title="CELUSTA Leave-In Conditioner"
          data-testid="judgeme-review-widget"
        ></div>
      </div>
    </section>
  );
};
